import { showMessage } from "./message";

function deg2rad(deg) {
    return deg * (Math.PI / 180)
}
export function distanciaEntreDuasCoordenadas(lat1, lon1, lat2, lon2) {
    var R = 6371; // raio da terra
    var Lati = Math.PI / 180 * (lat2 - lat1);  //Graus  - > Radianos
    var Long = Math.PI / 180 * (lon2 - lon1);
    var a =
        Math.sin(Lati / 2) * Math.sin(Lati / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(Long / 2) * Math.sin(Long / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // distância en km
    return d;
}
export function melhorarRota(pontos) {
    //pegando o ponto de partida
    const [partida] = pontos.filter(value => value.sequencia == 1)
    //conferindo se existe um ponto de partida
    if (!partida) {
        showMessage("Aviso", "Informe um um ponto com numero de sequencia 1 para melhorar a rota", "warning", null);
        return [];
    }
    //removendo o ponto de partida do vetor
    pontos = pontos.filter(value => value.sequencia != 1);
    //calculando a distancia entre os pontos em relação ao ponto de partida
    pontos = pontos.map(ponto => {
        ponto.distancia = distanciaEntreDuasCoordenadas(partida.latitude, partida.longitude, ponto.latitude, ponto.longitude);
        return ponto;
    });
    //organizando os pontos
    pontos.sort((a, b) => {
        if (b.distancia < a.distancia) {
            return 1;
        } else if (a.distancia < b.distancia) {
            return -1;
        } else {
            return 0;
        }
    });
    //salvando os novos valores da sequencia
    pontos = pontos.map((ponto, index) => {
        ponto.sequencia = index + 2;
        return ponto;
    })
    //incluindo novamento o ponto de partida na lista
    pontos.unshift(partida);

    return pontos;
}

export function conectarPontos(_pontos) {
    const _linhas = [];
    //ordenando os pontos de acordo com a sequencia
    _pontos.sort((a, b) => {
        if (a.sequencia > b.sequencia) {
            return 1;
        }
        if (a.sequencia < b.sequencia) {
            return -1;
        }
        return 0;
    });
    let i, j = 1;
    //salvando as coordenadas dos pontos que se conectam
    if (_pontos.length > 1) {
        for (i = 0; i < _pontos.length; i++) {
            if (i !== j && _pontos[i] != null && _pontos[i].latitude != null) {
                _linhas.push([[parseFloat(_pontos[i].latitude), parseFloat(_pontos[i].longitude)], [parseFloat(_pontos[j].latitude), parseFloat(_pontos[j].longitude)]]);
            }

            if (j !== _pontos.length - 1) {
                j++;
            }
        }
    }
    return _linhas;
}